import { render } from "./Diet.vue?vue&type=template&id=ebac95a8"
import script from "./Diet.vue?vue&type=script&lang=js"
export * from "./Diet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__